import base from "@/store/utils/api-route/base";

const whitelabelApi = {
    statusTransaksi: (id) =>  `${base.whitelabel}v1/transaction/status/${id}`,
    setting: `${base.whitelabel}/v1/setting`,
}

export default whitelabelApi